"use client";

export function PricingSlider({
  min,
  max,
  value,
  onChange,
  steps,
  "aria-label": ariaLabel,
}: {
  min: number;
  max: number;
  value: number;
  onChange: (v: number) => void;
  steps: number[];
  "aria-label"?: string;
}) {
  const pct = (steps.indexOf(value) / (steps.length - 1)) * 100;
  return (
    <div className="relative w-full py-1">
      <input
        type="range"
        min={0}
        max={steps.length - 1}
        value={steps.indexOf(value)}
        onChange={(e) => onChange(steps[Number(e.target.value)])}
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-label={ariaLabel ?? "Plan amount"}
        className="focus-visible:ring-ring focus-visible:ring-offset-background h-1.5 w-full cursor-pointer appearance-none rounded-full outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
        style={{
          background: `linear-gradient(to right, color-mix(in srgb, var(--foreground) 60%, transparent) ${pct}%, var(--border) ${pct}%)`,
        }}
      />
      <div
        className="pointer-events-none relative mx-[9px] mt-2.5 select-none"
        style={{ height: "6px" }}
      >
        {steps.map((s, i) => (
          <div
            key={s}
            className="absolute top-0 rounded-full"
            style={{
              width: "1px",
              height: "6px",
              left: `calc(${(i / (steps.length - 1)) * 100}% - 0.5px)`,
              backgroundColor:
                steps.indexOf(value) >= i
                  ? "color-mix(in srgb, var(--foreground) 60%, transparent)"
                  : "var(--border)",
            }}
          />
        ))}
      </div>
    </div>
  );
}

export const sliderThumbStyles = `
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--foreground);
    border: 2.5px solid var(--brand-green);
    box-shadow: 0 0 0 3px rgba(91,140,255,0.18), 0 2px 6px rgba(0,0,0,0.25);
    cursor: pointer;
  }
  input[type="range"]::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--foreground);
    border: 2.5px solid var(--brand-green);
    box-shadow: 0 0 0 3px rgba(91,140,255,0.18), 0 2px 6px rgba(0,0,0,0.25);
    cursor: pointer;
  }
`;
